<template>
    <v-row justify="center">
    <v-dialog
      v-model="show_duplicate"
      max-width="1200"
    >
      <v-card>
        <v-card-title class="text-h5">
          <v-row>

            <v-col cols="11">
              <v-alert
      color="primary"
      dark
      border="left"
      prominent
    >
      <h4><strong>{{produc_name}}</strong> <!-- :: <strong>{{product_name}}</strong>  --></h4>
    </v-alert>

            </v-col>
            <v-col cols="1">
              <v-btn
                  v-show="!hidden"
                  color="blue"
                  v-on:click="hidePopup"
                  fab
                  dark
                  small
                  top
                  right
                  class="mt-5"
                >
                  X
                </v-btn>
              <!-- <span v-on:click="hidePopup"></span> -->
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- left side -->
            <v-col cols="6">
              <v-row>
                <v-col cols="12">
                  <v-card
                    color="#385F73"
                    dark
                    class="pa-10"
                    style="height:127px"
                  >
                    <strong>ID</strong> : <span>{{original_muid}}</span>
                </v-card>

                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card
                    color="#385F73"
                    dark
                    class="pa-5"
                  >
                    <div class="original original_content" id="original_content" v-html="original_html"></div>
                </v-card>

                </v-col>
              </v-row>
            </v-col>
            <!-- right side -->
            <v-col cols="6">
              <v-row>
                <v-col cols="12">
                  <v-card
                    color="#385F73"
                    dark
                    class="pa-5"
                  >
                      <v-select
                        :items="duplicateOptions"
                        label="Duplicates"
                        outlined
                        v-model="duplicate_id"
                      ></v-select>
                </v-card>

                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card
                    color="#385F73"
                    dark
                    class="pa-5"
                  >
                    <div class="duplicate duplicate_content" id="duplicate_content" v-html="duplicate_html"></div>
                </v-card>

                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>

</template>
<script>
export default {
    name: 'DmduplicationCheck',
    data: () => ({
        readClass: "",
        duplicate_id: ''
    }),
    mounted() {
     
      let view = this
      view.duplicate_id = view.duplicate_muids[0]
      view.$store.dispatch('Dmduplicate/setDuplicateForId', '').then(function(){
        view.fetchDmduplicate(view, view.duplicate_id, 'original');
      });
      view.$store.dispatch('Dmduplicate/setOriginalHtml', '').then(function(){
        view.fetchDmduplicate(view, view.dmdupObject.id, 'gmail_client')
      });
    },
    computed: {
      duplicateOptions: function(){
        let duplicates = this.dmdupObject.duplicates.toString().split(',')
        let options = []
        duplicates.forEach((o)=>{
          options.push({text:o,value:o})
        })
        return options
      },
      duplicate_muids : function(){
        return this.dmdupObject.duplicates.toString().split(',')
      },
      original_muid: function(){
        return this.dmdupObject.id
      },
      original_html: function(){
        return this.$store.getters['Dmduplicate/getOriginalHtml']
      },
      product_name: function(){
        return this.dmdupObject.product_name
      },
      sender: function(){
        return this.dmdupObject.original_sender_name
      },
      duplicate_html: function(){
        return this.$store.getters['Dmduplicate/getDuplicateForId']
      }
    },
    props: [
        "dmdupObject",
        "show_duplicate"
    ],
    methods: {
      hidePopup: function(){
        this.$emit('hidePopup', true)
      },
      fetchDmduplicate: function (view, id, type) {
       
        view.$fetch({ requiresAuth: true, operation : 'add' , vueScope: view })
            .post(view.$url('DMDUPLICATES_SEARCH'), JSON.stringify({ "id": id, type: type }), {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
        .then(function (res) {
          let response = res.data
            typeof response.payload !== 'undefined' ? (response.type === 'original' ? view.$store.dispatch('Dmduplicate/setDuplicateForId', response.payload) : view.$store.dispatch('Dmduplicate/setOriginalHtml', response.payload)) : ''
        }).catch(function (e) {
            console.log(e)
        })
    },
    },
    watch: {
      duplicate_id : function(o){
        let view = this
         view.fetchDmduplicate(view, o, 'original')
      }
    }
}
</script>
